<template>
  <footer class="page-footer">
    <div class="footer-content">
      <p>
<!--        <span>© 2024 My Website. All rights reserved.</span>-->
<!--        <span class="divider">|</span>-->
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          {{ beianNumber }}
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
    return {
      beianNumber: '晋ICP备2026000928号-1'
    }
  }
}
</script>

<style scoped>
.page-footer {
  background-color: #f8f9fa;
  color: #666;
  padding: 0 0;
  text-align: center;
  border-top: 1px solid #eee;
  width: 100%;
  margin-top: auto;
}

.footer-content {
  font-size: 14px;
  line-height: 20px;
}

.divider {
  margin: 0 10px;
  color: #ccc;
}

.footer-content a {
  color: #666;
  text-decoration: none;
}

.footer-content a:hover {
  color: #333;
  text-decoration: underline;
}

/* 仅在屏幕宽度小于等于 768px 时隐藏 */
@media screen and (max-width: 768px) {
  .page-footer {
    display: none;
  }
}
</style>
